import React from 'react';

interface StickyFooterProps {
  children: React.ReactNode;
  className?: string;
}

/**
 * A footer that sticks to the bottom of the viewport and overlays content.
 * Use this for action buttons and controls that should always be visible.
 * Includes safe-area padding for devices with home indicators.
 */
export const StickyFooter: React.FC<StickyFooterProps> = ({ children, className = '' }) => {
  return (
    <div
      className={`fixed bottom-0 left-0 right-0 bg-secondary border-t border-surface-light p-4 pb-safe-bottom space-y-3 z-40 ${className}`}
    >
      {children}
    </div>
  );
};

export default StickyFooter;
